import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["as", "condensed", "narrow", "fullWidth", "className", "children"];
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import cx from 'classnames';
import React from 'react';
import { usePrefix } from '../../internal/usePrefix.js';
import { GridSettings } from './GridContext.js';
var FlexGrid = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _cx;
  var as = _ref.as,
    _ref$condensed = _ref.condensed,
    condensed = _ref$condensed === void 0 ? false : _ref$condensed,
    _ref$narrow = _ref.narrow,
    narrow = _ref$narrow === void 0 ? false : _ref$narrow,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    containerClassName = _ref.className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var prefix = usePrefix();
  var className = cx(containerClassName, (_cx = {}, _defineProperty(_cx, "".concat(prefix, "--grid"), true), _defineProperty(_cx, "".concat(prefix, "--grid--condensed"), condensed), _defineProperty(_cx, "".concat(prefix, "--grid--narrow"), narrow), _defineProperty(_cx, "".concat(prefix, "--grid--full-width"), fullWidth), _cx));
  // cast as any to let TypeScript allow passing in attributes to base component
  var BaseComponent = as || 'div';
  return /*#__PURE__*/React.createElement(GridSettings, {
    mode: "flexbox",
    subgrid: false
  }, /*#__PURE__*/React.createElement(BaseComponent, _extends({
    className: className,
    ref: ref
  }, rest), children));
});
var FlexGridComponent = FlexGrid;
export { FlexGridComponent as FlexGrid };